import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import ShareMenu from './components/ShareMenu';
import readingProgress from './service/ReadingProgressService';
import shareData from './service/shareData';
const PUBLICATION_TYPES = new Set(['article', 'guide', 'blog']);
function isPublication(discussion) {
  return discussion && PUBLICATION_TYPES.has(discussion.contentType());
}
export default function addPublicationReadingControls() {
  extend(CommentPost.prototype, 'oncreate', function () {
    const post = this.attrs.post;

    // Прогресс относится ко всей публикации и включается только после появления первого сообщения,
    // когда браузер уже может измерить реальную высоту отформатированного текста.
    if (Number(post.number()) === 1 && isPublication(post.discussion())) {
      readingProgress.activate(post.discussion());
    }
  });
  extend(DiscussionPage.prototype, 'onremove', function () {
    // При уходе со страницы удаляем глобальный обработчик и индикатор, чтобы они не попадали
    // в обычную ленту, настройки профиля или следующую тему.
    readingProgress.deactivate();
  });
  extend(CommentPost.prototype, 'footerItems', function (items) {
    const post = this.attrs.post;
    const discussion = post.discussion();
    if (Number(post.number()) !== 1 || !isPublication(discussion)) return;
    items.add('devconnect-reading-tools', m('div.dc-reading-tools', [m('span.dc-reading-time', [m('i.far.fa-clock', {
      'aria-hidden': 'true'
    }), `${Math.max(1, Number(discussion.readingTime()) || 1)} мин чтения`]), m(ShareMenu, {
      data: shareData(post)
    })]), 110);
  });
}